/* Auto-generated by scripts/generate-version.js — do not edit by hand. */
import { AppVersionInfo } from '../interfaces/app-version.interface';

/** Fingerprint of the JS bundle currently running in the browser. */
export const APP_VERSION: AppVersionInfo = {
  "version": "5524-4dfae7cf429f85a79e46c511bd846a4ac753e0cd",
  "buildTime": "2026-09-07T11:28:58.663Z"
};
